import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import DeleteModal from "../../../Components/Common/DeleteModal";
import UnitForm from "../component/UnitForm";
import UnitService from "../../../services/OrderingServices/UnitService";
import UnitConversionForm from "../component/UnitConversionForm";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const UnitConversion = () => {
  const [unitList, setUnitList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedItem, setSelectedCustomer] = useState();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "From Unit",
      selector: (row) => `${row?.fromUnitName}`,
      cell: (row) => row.fromUnitName,
      sortable: true,
    },
    {
      name: "To Unit",
      selector: (row) => `${row?.toUnitName}`,
      cell: (row) => row.toUnitName,
      sortable: true,
    },
    {
      name: "Conversion Factor",
      selector: (row) => row.conversionFactor,
      sortable: true,
      right: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => {
              setAddModal(true);
              setSelectedCustomer(row);
            }}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  const fetchUnitConversion = async () => {
    try {
      setLoading(true);
      const response = await UnitService.getUnitConversion();

      setUnitList(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchUnitConversion();
  }, []);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = unitList.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.name || ""}`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedCustomer(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedItem) {
      try {
        await UnitService.deleteConversion(selectedItem);
        setUnitList((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedItem),
        );
        toast.success("Selected unit conversion deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedCustomer(null);
      }
    }
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Unit List" pageTitle="Unit" />
      </div>
      <Row>
        <Col md={8} xs={12} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by unit name"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-flex justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            + Add Unit
          </button>
        </Col>
      </Row>
      <div className="d-none d-md-block d-lg-block">
      <Card>
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card>
      </div>
      <div className="d-block d-md-none">
        {loading ? (
  <div className="my-5 d-flex justify-content-center">
    <Triangle
      visible={true}
      height="60"
      width="60"
      color="#5B71B9"
      ariaLabel="triangle-loading"
    />
  </div>
) : (
  <>
    {filteredData?.map((item, index) => (
      <Card
        key={item.id || index}
        className="mb-3 shadow-sm d-block d-lg-none"
      >
        <CardBody>
          <Row>
            <Col xs={10}>
              <h6 className="mb-2">From Unit: {item.name}</h6>
              <h6 className="mb-2 text-muted">
                To Unit: {item.name}
              </h6>
              <h6 className="mb-2 text-muted">
                Conversion Factor: {item.conversionFactor}
              </h6>
              <h6 className="mb-2 text-muted">
                Description: {item.description || 'N/A'}
              </h6>
            </Col>
            <Col xs={2}>
              <div>
                <Dropdown
                  isOpen={item.dropdownOpen || false}
                  toggle={(e) => {
                    e.stopPropagation();
                    setUnitList((prev) =>
                      prev.map(
                        (unit) =>
                          unit.id === item.id
                            ? {
                                ...unit,
                                dropdownOpen: !unit.dropdownOpen,
                              }
                            : { ...unit, dropdownOpen: false }
                      )
                    );
                  }}
                  direction="down"
                >
                  <DropdownToggle
                    color="primary"
                    outline
                    className="btn-sm shadow-sm rounded-circle"
                  >
                    <i className="ri-more-2-fill"></i>
                  </DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem
                      onClick={(e) => {
                        e.stopPropagation();
                        setAddModal(true);
                        setSelectedCustomer(item);
                      }}
                    >
                      <i className="ri-edit-line text-warning me-2"></i>{" "}
                      Edit
                    </DropdownItem>
                    <DropdownItem
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteClick(item.id);
                      }}
                    >
                      <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                      Delete
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    ))}
  </>
)}

      </div>
      <UnitConversionForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedCustomer(null); // Clear editing state when closing
        }}
        setUnitList={setUnitList}
        unitList={unitList}
        selectedItem={selectedItem}
        fetchUnitConversion={fetchUnitConversion}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedItem} // Pass the selected item
      />
    </div>
  );
};

export default UnitConversion;
